import { g as F } from "./_commonjsHelpers-B52_cu2H.js";
import { r as G, a as E, b as U, c as K } from "./_baseGet-Dc2RMIwt.js";
import { r as S, a as x, b as D, c as I, d as M } from "./_flatRest-BxsRCdXt.js";
import { r as N } from "./_baseSlice-DXcRLrdm.js";
var m, C;
function w() {
  if (C) return m;
  C = 1;
  function t(e) {
    var r = e == null ? 0 : e.length;
    return r ? e[r - 1] : void 0;
  }
  return m = t, m;
}
var c, g;
function B() {
  if (g) return c;
  g = 1;
  var t = G(), e = N();
  function r(a, i) {
    return i.length < 2 ? a : t(a, e(i, 0, -1));
  }
  return c = r, c;
}
var q, L;
function T() {
  if (L) return q;
  L = 1;
  var t = E(), e = w(), r = B(), a = U();
  function i(n, u) {
    return u = t(u, n), n = r(n, u), n == null || delete n[a(e(u))];
  }
  return q = i, q;
}
var v, b;
function Y() {
  if (b) return v;
  b = 1;
  var t = S();
  function e(r) {
    return t(r) ? void 0 : r;
  }
  return v = e, v;
}
var O, p;
function k() {
  if (p) return O;
  p = 1;
  var t = K(), e = x(), r = T(), a = E(), i = D(), n = Y(), u = I(), R = M(), y = 1, A = 2, P = 4, h = u(function(o, l) {
    var s = {};
    if (o == null)
      return s;
    var _ = !1;
    l = t(l, function(f) {
      return f = a(f, o), _ || (_ = f.length > 1), f;
    }), i(o, R(o), s), _ && (s = e(s, y | A | P, n));
    for (var d = l.length; d--; )
      r(s, l[d]);
    return s;
  });
  return O = h, O;
}
var z = k();
const W = /* @__PURE__ */ F(z);
export {
  W as o
};
